<template>
  <div>
    <v-form v-model="valid" class="container">
      <h1 class="text-h5 text-md-h2 text text--white ma-8 text--center">Pós-vendas Gali</h1>
      
      <div 
        v-if="mostrarAviso" 
        :class="['aviso-procedimento', { 'slide-out-tl': fechandoAviso }]"
      >
        <div class="aviso-content">
          <v-icon class="aviso-icon" color="white">mdi-information-outline</v-icon>
          <div class="aviso-texto">
            <h4>Precisa de ajuda?</h4>
            <p>Clique no botão <v-icon small>mdi-information</v-icon> no canto inferior direito para acessar o <strong>Procedimento de Acionamento de Garantia</strong> - um passo a passo completo para te auxiliar!</p>
          </div>
          <v-btn 
            icon 
            small 
            class="aviso-close" 
            @click="fecharAviso"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <v-btn
        color="secondary"
        class="fab-guia"
        @click="downloadProcedimento"
        rounded
      >
        <v-icon>mdi-information</v-icon>
      </v-btn>

      <p class="text-subtitle text-md-h6 text--white ma-8 text--center">
        Seja bem-vindo a central de apoio ao cliente em atendimentos de
        pós-vendas da Gali energia.<br />
        Preencha os dados abaixo para que possamos realizar a abertura do ticket
        de atendimento.
      </p>
      <v-stepper v-model="e1" vertical color="secondary">
        <v-stepper-step :complete="e1 > 1" step="1">
          Dados Pessoais
        </v-stepper-step>
        <v-stepper-content step="1">
          <h3 class="text-subtitle-1 mb-4">
            Os dados abaixo devem ser preenchidos para melhor comunicação e
            interação entre nossa equipe e você.
          </h3>
          <info-inicial
            :dados.sync="dadosPessoais"
            @changePagina="mudarPagina"
          ></info-inicial>
        </v-stepper-content>

        <template v-if="possuiSatisfacaoAberta">
          <v-stepper-step :complete="e1 > 2" step="2">
            Satisfações Abertas
          </v-stepper-step>
          <v-stepper-content step="2">
            <h3 class="text-subtitle-1 mb-4">
              Foram encontrados alguns tickets finalizados no seu email, deseja
              responder nossa pesquisa de satisfação?
            </h3>

            <h2>{{ satisfacoesAbertas[0].email }}</h2>
            <div v-for="satisfacao in satisfacoesAbertas" :key="satisfacao">
              <v-spacer></v-spacer>
              <v-card-text>
                <v-row class="pa-3">
                  <v-col style="font-size: 1.3em; display: flex">
                    <p style="font-weight: 600">
                      {{ satisfacao.ticket }} -&nbsp;
                    </p>
                    {{ exibeData(satisfacao.dataAbertura) }}</v-col
                  >
                  <v-col cols="3">
                    <v-btn color="primary" @click="abreSatisfacao(satisfacao)">
                      <v-icon> mdi-open-in-new </v-icon></v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-text>
            </div>

            <div v-if="satisfacoesAbertasObra.length">
              <h2>{{ satisfacoesAbertasObra[0].email }}</h2>
              <div
                v-for="satisfacao in satisfacoesAbertasObra"
                :key="satisfacao"
              >
                <v-spacer></v-spacer>
                <v-card-text>
                  <v-row class="pa-3">
                    <v-col style="font-size: 1.3em; display: flex">
                      <p style="font-weight: 600">
                        {{ satisfacao.ticket }} -&nbsp;
                      </p>
                      {{ exibeData(satisfacao.dataAbertura) }}</v-col
                    >
                    <v-col cols="3">
                      <v-btn
                        color="primary"
                        @click="abreSatisfacao(satisfacao)"
                      >
                        <v-icon> mdi-open-in-new </v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </div>
            </div>

            <v-btn variant="text" class="mb-12 ml-4" @click="next(1)">
              <v-icon>mdi-arrow-left</v-icon> Voltar</v-btn
            >
            <v-btn color="secondary" class="mb-12 ml-4" @click="next(3)"
              >Não</v-btn
            >
          </v-stepper-content>
        </template>

        <v-stepper-step
          :complete="e1 > 3"
          :step="possuiSatisfacaoAberta ? '3' : '2'"
        >
          Informações técnicas:
        </v-stepper-step>

        <v-stepper-content :step="possuiSatisfacaoAberta ? 3 : 2">
          <h3 class="text-subtitle-1 mb-4">
            Preencha os campos com as informações essenciais para direcionarmos
            o tipo de atendimento solicitado.
          </h3>

          <info-problema
            :dados.sync="dadosTecnicos"
            @changePagina="next"
          ></info-problema>

          <v-col cols="12">
            <p class="text-subtext-1 font-weight-bold text-center">
              *Ao preencher e clicar em enviar voce está dando consentimento
              para o armazenamento e uso dos seus dados para posterior contato
              pela Gali. Estes dados ficam a disposição da empresa pelo período
              que for necessário para atendimento.
            </p>
          </v-col>
        </v-stepper-content>
      </v-stepper>

      <v-snackbar
        style="position: fixed"
        :timeout="5000"
        :value="err"
        absolute
        center
        shaped
        bottom
        elevation="12"
        color="red accent-2"
        app
      >
        Ocorreu um erro <strong>ao enviar</strong> o formulário.
        <br />
        Por favor, tente novamente mais tarde.
      </v-snackbar>
    </v-form>
  </div>
</template>

<script>
import InfoInicial from "./InfoInicial.vue";
import InfoProblema from "./InfoProblema.vue";
// eslint-disable-next-line no-unused-vars
import API from "../api/API";
import jwt from "jsonwebtoken";

export default {
  components: {
    InfoInicial,
    InfoProblema,
  },
  data: () => ({
    valid: false,
    dialog: false,
    e1: 1,
    dadosPessoais: {},
    dadosTecnicos: {},
    err: false,
    satisfacoesAbertas: [],
    satisfacoesAbertasObra: [],
    mostrarAviso: true,
    fechandoAviso: false,
  }),
  computed: {
    // a computed getter
    possuiSatisfacaoAberta: function () {
      // `this` points to the vm instance
      this.satisfacoesAbertas;
      this.satisfacoesAbertasObra;
      return !!(
        this.satisfacoesAbertas.length || this.satisfacoesAbertasObra.length
      );
    },
  },
  methods: {
    downloadProcedimento() {
      try {
        window.open(
          "/PROCEDIMENTO DE ACIONAMENTOS DE GARANTIA REV2 1.pdf",
          "_blank"
        );
      } catch (error) {
        console.error("Erro ao abrir o arquivo:", error);
        this.err = true;
      }
    },

    fecharAviso() {
      this.fechandoAviso = true;
      setTimeout(() => {
        this.mostrarAviso = false;
        this.fechandoAviso = false;
      }, 900);
    },

    abreSatisfacao(satisfacao) {
      const token = jwt.sign({ idSatisfacao: satisfacao.SK }, "GALIENERGIA", {
        expiresIn: "1 days",
      });

      let route = this.$router.resolve({
        name: "FormularioSatisfacao",
        params: { ticketJwt: token },
      });
      window.open(`#${route.resolved.fullPath}`, "_blank");
    },

    async verificaSatisfacoesAbertas() {
      this.satisfacoesAbertas = [];
      this.satisfacoesAbertasObra = [];
      this.satisfacoesAbertas = await API.buscarSatisfacaoByEmail(
        this.dadosPessoais.email
      );
      this.satisfacoesAbertasObra = await API.buscarSatisfacaoByEmail(
        this.dadosPessoais.emailSecundario
      );

      const todasAbertas = this.satisfacoesAbertas.concat(
        this.satisfacoesAbertasObra
      );
      console.log("todasAbertas", todasAbertas);
    },
    async mudarPagina(page) {
      console.log("mudarPagina", page);
      await this.verificaSatisfacoesAbertas();
      this.next(page);
    },
    async next(page) {
      if (page) this.e1 = page;
      else await this.enviarForm();
    },
    async enviarForm() {
      this.$emit("carregando", true);
      this.err = false;
      try {
        const formCompleto = {
          ...this.dadosPessoais,
          ...this.dadosTecnicos,
        };
        const resp = await API.enviarForm(formCompleto);
        if (resp.status !== 200) throw resp;
        this.$emit("carregando", false);
        this.$emit("finalizado", {
          status: true,
          ticket: resp.data.id_ticket,
        });
      } catch (error) {
        this.err = true;
        this.$emit("carregando", false);
      }
    },
    exibeData(data) {
      return new Date(data).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
      });
    },
  },
};
</script>

<style lang="scss">
.text--white {
  color: white;
}
.text--center {
  text-align: center;
}
.form-principal {
  display: flex;
  flex-direction: column;
}
.download-btn {
  margin: 16px 0;
}
.fab-guia {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  width: 56px !important;
  height: 56px !important;
  
  .v-icon {
    font-size: 24px !important;
  }
}

.aviso-procedimento {
  position: fixed;
  bottom: 100px;
  right: 24px;
  max-width: 350px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  z-index: 15;
  animation: slide-in-br 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

.aviso-content {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  color: white;
  position: relative;
}

.aviso-icon {
  margin-right: 12px;
  margin-top: 4px;
  font-size: 24px !important;
}

.aviso-texto {
  flex: 1;
  
  h4 {
    margin: 0 0 8px 0;
    font-size: 16px;
    font-weight: 600;
  }
  
  p {
    margin: 0;
    font-size: 14px;
    line-height: 1.4;
    opacity: 0.9;
  }
}

.aviso-close {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(255, 255, 255, 0.2) !important;
  
  &:hover {
    background: rgba(255, 255, 255, 0.3) !important;
  }
}

@keyframes slide-in-br {
  0% {
    -webkit-transform: translateX(1000px);
            transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
            transform: translateX(0);
    opacity: 1;
  }
}

.slide-out-tl {
  animation: slide-out-tl 0.9s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
}

@keyframes slide-out-tl {
  0% {
    -webkit-transform: translateX(0);
            transform: translateX(0);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(1000px);
            transform: translateX(1000px);
    opacity: 1;
  }
}

@media (max-width: 480px) {
  .aviso-procedimento {
    right: 16px;
    left: 16px;
    max-width: none;
    bottom: 90px;
  }
  
  .aviso-content {
    padding: 12px;
  }
  
  .aviso-texto {
    h4 {
      font-size: 14px;
    }
    
    p {
      font-size: 13px;
    }
  }
}
</style>